<template>
  <v-app>
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container fluid fill-height align-start >
        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card color="#393E46">
            <v-card-title class="text-h5">
              {{ $t('alertas.titulodatos') }}
            </v-card-title>
            <v-card-text>{{ $t('alertas.nuevalista') }}</v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>

        <v-dialog v-model="dialogdelete" persistent max-width="350">
          <v-card color="#393E46">
            <v-card-title class="headline">Desea eliminar esta Persona de la Lista?</v-card-title>
            <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="close">No</v-btn>
              <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

          <v-row align="center" class="text-center">
            <v-col cols="12" sm="12" md="12" lg="12">
              <h1  class="display-1 font-weight-bold" style="color: #393E46;">
                Hola {{promotor.promotorNombre}}
              </h1>
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12" sm="12" md="12" lg="12">
          <v-card color="#393E46">
            <v-card-text>
            <v-autocomplete  v-model="fiestaid" :items="fiestas" item-value="id" item-text="nombre" @change="damelista"  persistent-hint

                               single-line label="Escoger Fiesta"></v-autocomplete>


              <v-data-table
                  :headers="headers"
                  :items="listas"
                  sort-by="fechaActo"
                  sort-desc
                  class="elevation-1"
                  :search="search"
                  :loading="progr"
                  no-data-text="No hay datos disponibles para mostrar."
                  no-results-text="No hay resultados para la búsqueda."
                  loading-text="Cargando... Por favor espere."
                  style="background-color: #393E46;"
              >
                <template v-slot:top>
                  <v-toolbar flat >
                    <v-toolbar-title>Lista de Fiestas Activas</v-toolbar-title>

                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon
                      small
                      v-if="item.actoActivo"
                      color="primary"
                      class="mr-2"
                      @click="editItem(item)"
                  >
                    fas fa-edit
                  </v-icon>
                  <v-icon
                      v-if="item.actoActivo"
                      small
                      color="error"
                      @click="deleteItem(item)"
                  >
                    fas fa-minus-circle
                  </v-icon>
                </template>

              </v-data-table>
            </v-card-text>
          </v-card>
            </v-col>
          </v-row>

        <leftsinmenupromotor  />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"
          />
        </v-overlay>

      </v-container>
    </v-main>
    <piepagina />
  </v-app>
</template>

<script>
import axios from 'axios';
import moment from "moment-timezone";
import leftsinmenupromotor from "@/components/general/leftsinmenupromotor";
import {mapGetters} from "vuex";
import firebase from 'firebase/compat/app';
import Piepagina from "@/components/general/piepagina";
export default {
  name: "listaspromotor",
  components: {
    Piepagina,
    leftsinmenupromotor
  },
  data () {
    return{
      negocitag: '',
      overlay:false,
      alertnuevo:false,
      logoexist: false,
      logoimg: null,
      progr:false,
      token:'',
      mostrarlista:true,
      fiestaid:0,
      search: '',
      editedIndex: -1,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      headers: [
        { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Fiesta', align: 'left',  value: 'nombreActo'},
        { text: 'Fecha', value: 'fechaActo' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Tipo de Lista', value: 'tipoLista'},
        { text: 'Codigo para Registro', value: 'codigoUnico'},
      ],
      promotor:{},
      fiestas: [],
      dialogdelete: false,
      tipolistas:[],
      listas:[],
      lista:{},
      editedItem: {
        id:0,
        listaFiesta:{
          id:0,
          titular:'',
          promotor:{},
          tipoLista:{},
          fiesta:{},
          createdAt: '2020-01-01 00:00:00'
        },
        nombre:'',
        codigoUnico:'',
        personaId:0,
        fechaIngreso:null,
        f:false,
        createdAt: '2020-01-01 00:00:00'
      },

    }
  },
  mounted (){
    this.negocitag =  this.$route.params.idnegocio;
    if(this.usuario.id>0){
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.damepromotor();
    }else{
      this.$router.push({ path: '/' });

    }
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    editItem (item) {
      this.editedIndex = this.listas.indexOf(item)
      this.lista = Object.assign({}, item)
      this.editedItem.listaFiesta.fiesta.fiestaInicio = this.formatDate(new Date(this.editedItem.listaFiesta.fiesta.fiestaInicio))
      this.editedItem.dateCreated = this.formatDateee(new Date(this.editedItem.dateCreated))
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },
    damelista(){
      this.overlay = true;
      let urlfiesta = 'lista/fiesta/promotor';
      var bodyFormData = new FormData();
      bodyFormData.append("fiestaId",this.fiestaid);
      bodyFormData.append("promotorId",this.promotor.id);
      axios
          .post(urlfiesta,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.listas = response.data;
            this.overlay = false;
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false;
          });
    },

    formatDarete (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    damefiestas(){
      this.overlay = true;
      let urlfiesta = 'promotores/fiestas/todas';
      var bodyFormData = new FormData();

      bodyFormData.append("promotorId",this.promotor.id);

      axios
          .post(urlfiesta,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.fiestas = response.data;
            if(this.fiestas.length>0){
            this.fiestaid = this.fiestas[this.fiestas.length-1].id
              this.damelista()
            }
            this.overlay = false;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damepromotor(){
      this.overlay = true
      var bodyFormData = new FormData();
      bodyFormData.append("tag",this.negocitag);
      bodyFormData.append("personaId",this.usuario.id);
      axios
          .post('promotores/lista',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.promotor = response.data;
            this.editedItem.listaFiesta.promotor = this.promotor
            this.damefiestas()
            this.overlay = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
          });
    },

    borralo (){
      this.overlay = true
      axios
          .delete('lista/'+ this.listas[this.editedIndex].codigoUnico,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialogdelete = false;
            this.listas=response.data
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
            this.overlay = false
          });
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>

<style scoped>

</style>